import React, { useState, useEffect, useRef } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const ProductDetailsWithTabs = ({
  product,
  isOwned,
  isLoggedIn,
  addingToCart,
  checkingOwnership,
  handleBuyNow,
  handleAddToCart,
  handleWishlistClick,
  isProductInWishlist,
  navigate,
  convertInchesToCm,
  ImageWithLoader ,
  sizes,
  canvasWrap,
  frame,
  selectedFrame,
  selectedSize,
  selectedCanvas,
  setSelectedFrame,
  setSelectedSize,
  setSelectedCanvas,
  printMaterial,
  selectedPrintMaterial,
  setSelectedPrintMaterial ,
  handleSoundClick,
  speakerFlag 
}) => {
  console.log("sizes" , sizes)
  const [activeTab, setActiveTab] = useState('original');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showFullImage, setShowFullImage] = useState(false);
  const mainCarouselRef = useRef(null);
  
  // Print options state
  // const [selectedMaterial, setSelectedMaterial] = useState('Canvas');
  // const [selectedSize, setSelectedSize] = useState('12 × 18 in ($42)');
  // const [selectedWrap, setSelectedWrap] = useState('Black Canvas');
  // const [selectedFrame, setSelectedFrame] = useState('No Frame');
  
  // Dropdown open/close states
  const [isMaterialOpen, setIsMaterialOpen] = useState(false);
  const [isSizeOpen, setIsSizeOpen] = useState(false);
  const [isWrapOpen, setIsWrapOpen] = useState(false);
  const [isFrameOpen, setIsFrameOpen] = useState(false);

  // Refs for dropdown containers
  const materialRef = useRef(null);
  const sizeRef = useRef(null);
  const wrapRef = useRef(null);
  const frameRef = useRef(null);


 


  const materials = ['Canvas', 'Metal', 'Fine Art Paper', 'Acrylic'];
  // const sizes = [
  //   { label: '12 × 18 in', price: 42 },
  //   { label: '24 × 32 in', price: 284 },
  //   { label: '30 × 40 in', price: 485 }
  // ];
  const wraps = ['Black Canvas', 'White Canvas'];
  // const frames = [
  //   { label: 'No Frame', price: 0 },
  //   { label: 'White', price: 135 },
  //   { label: 'Black', price: 135 }
  // ];

  // Calculate total price
  const calculateTotalPrice = () => {
    const sizePrice = sizes.find(s => selectedSize?.name?.includes(s.name))?.price || 0;
    const framePrice = frame.find(f => selectedFrame?.name === f.name)?.price || 0;
    return sizePrice + framePrice;
  };

const sliderImages = Array.from(new Set([
  product?.image,
  ...(product?.subImages || []),
])).filter(img => 
  img !== null && 
  img !== undefined && 
  typeof img === "string" && 
  img.trim() !== ""
);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (materialRef.current && !materialRef.current.contains(event.target)) {
        setIsMaterialOpen(false);
      }
      if (sizeRef.current && !sizeRef.current.contains(event.target)) {
        setIsSizeOpen(false);
      }
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setIsWrapOpen(false);
      }
      if (frameRef.current && !frameRef.current.contains(event.target)) {
        setIsFrameOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  

  return (
    <section id="product_collection_details_1">
      <div className="container">
        <div className="row">
          {/* Left Column - Product Images */}
          <div className="col-xl-6 mb-4 mb-xl-0">
            <div className="d-flex gap-1 flex-column flex-md-row">
              {/* Main Image - First in DOM order */}
              <div
                className="position-relative overflow-hidden order-1 order-md-2"
                style={{ flex: 1 }}
              >
                <Carousel
                  ref={mainCarouselRef}
                  arrows={sliderImages.length > 1}
                  swipeable={true}
                  draggable={true}
                  showDots={false}
                   customTransition="all 800ms ease-in-out" 
                  infinite={false}
                  responsive={{
                    desktop: {
                      breakpoint: { max: 3000, min: 1024 },
                      items: 1,
                    },
                    tablet: {
                      breakpoint: { max: 1024, min: 464 },
                      items: 1,
                    },
                    mobile: {
                      breakpoint: { max: 464, min: 0 },
                      items: 1,
                    },
                  }}
                  beforeChange={(nextSlide) => {
                    setCurrentImageIndex(nextSlide);
                  }}
                >
                  {sliderImages.map((img, idx) => (
                    <div key={idx} className="position-relative">
                      {ImageWithLoader ? (
                        <ImageWithLoader
                          src={img}
                          alt={`product_detail_img_${idx}`}
                          className="w-100"
                          style={{
                            width: "100%",
                            height: "auto",
                            maxHeight: "802px",
                            objectFit: "contain",
                            backgroundColor: "#f8f9fa"
                        
                          }}
                          activeCollection = {'Canvas'}
                        />
                      ) : (
                        <img
                          src={img}
                          alt={`product_detail_img_${idx}`}
                          className="w-100"
                          style={{
                            width: "100%",
                            height: "auto",
                            maxHeight: "802px",
                            objectFit: "contain",
                            backgroundColor: "#f8f9fa"
                          }}
                        />
                      )}
                      <button
                        onClick={() => setShowFullImage(true)}
                        style={{
                          position: 'absolute',
                          bottom: '20px',
                          right: '20px',
                          width: '46px',
                          height: '46px',
                          background: '#FFFFFF',
                          border: 'none',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                          zIndex: 10,
                          cursor: 'pointer'
                        }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15 3H21V9" stroke="#112C3B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M9 21H3V15" stroke="#112C3B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M21 3L14 10" stroke="#112C3B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M3 21L10 14" stroke="#112C3B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </Carousel>
              </div>

              {/* Thumbnails - Second in DOM but using order classes to control position */}
              {sliderImages.length > 1 && (
                <div
                  className="d-flex flex-row flex-md-column gap-2 overflow-auto mt-3 mt-md-0 order-2 order-md-1"
                  style={{
                    maxHeight: "802px",
                    width: "auto",
                    maxWidth: "100%",
                    flexShrink: 0
                  }}
                >
                  {sliderImages.map((img, idx) => (
                    <div
                      key={idx}
                      className={`thumbnail_item ${idx === currentImageIndex ? "active" : ""}`}
                      onClick={() => {
                        setCurrentImageIndex(idx);
                        mainCarouselRef.current.goToSlide(idx);
                      }}
                      style={{
                        width: "80px",
                        height: "80px",
                        cursor: "pointer",
                        border: idx === currentImageIndex ? "2px solid #112C3B" : "1px solid #E5E7EB",
                        borderRadius: "8px",
                        overflow: "hidden",
                        transition: "all 0.2s ease",
                        flexShrink: 0
                      }}
                    >
                      <img
                        src={img}
                        alt={`thumbnail_${idx}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          opacity: idx === currentImageIndex ? 1 : 0.6
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Right Side: Product Info with Tabs */}
          <div className="col-xl-6">
            <div className="product_collection_details_info_area font_two">
              {/* Product Title & Wishlist */}
              <div className="product_collection_details_title_box d-flex flex-column">
                <div className="product_collection_details_title_inner_box d-flex flex-column">
                  <div className="product_collection_details_title_area d-sm-flex justify-content-sm-between d-grid">
                    <div style={{display :'flex' , alignItems :'center' , gap :'16px' , flexWrap :'wrap'}}>
                    <h2 className="collection_details_heading font_one">
                      {product?.name}
                    </h2>
                    <img src={speakerFlag ? "/assets/images/volume-on.svg" : '/assets/images/volume-off.svg'} width={30} height={30} onClick={handleSoundClick} style={{cursor : 'pointer'}}/>

                    </div>

                    {isLoggedIn && (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleWishlistClick(product?._id);
                        }}
                        className="product_like_btn d-md-flex d-none mt-xxl-4 mt-lg-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M18.8569 3.74471C14.8652 1.60384 11.9991 4.75972 11.9991 4.75972C11.9991 4.75972 9.13283 1.60383 5.14113 3.7447C0.306417 6.3377 -0.0407534 16.492 11.9991 21C24.0389 16.492 23.6916 6.33771 18.8569 3.74471Z"
                            stroke="#112C3B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            fill={
                              isProductInWishlist(product._id)
                                ? "#112C3B"
                                : "none"
                            }
                          />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>

                {/* Tab Navigation */}
                <div className="product_tabs_navigation" style={{
                  display: 'flex',
                  gap: '0',
                  marginBottom: '30px',
                  marginTop: '20px',
                  borderBottom: '1px solid #e5e7eb'
                }}>
                  <button
                    onClick={() => setActiveTab('original')}
                    style={{
                      flex: 1,
                      padding: '12px 24px',
                      background: activeTab === 'original' ? '#112C3B' : 'transparent',
                      color: activeTab === 'original' ? '#fff' : '#112C3B',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.3s ease',
                      borderRadius: '0'
                    }}
                  >
                    Original
                  </button>
                  <button
                    onClick={() => setActiveTab('prints')}
                    style={{
                      flex: 1,
                      padding: '12px 24px',
                      background: activeTab === 'prints' ? '#112C3B' : 'transparent',
                      color: activeTab === 'prints' ? '#fff' : '#112C3B',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.3s ease',
                      borderRadius: '0'
                    }}
                  >
                    Prints
                  </button>
                </div>

                {/* Tab Content */}
                {activeTab === 'original' ? (
                  // ORIGINAL TAB CONTENT
                  <>
                  <div style={{display : 'flex' , alignItems :'center' , flexWrap : 'wrap' , justifyContent : 'space-between'}}>
                    <p className="collection_details_price fw_700 d-sm-inline-block d-none">
                      ${product?.price?.toFixed(2) || "0.00"}
                    </p>
                    <div className="payment_details_btn_area">
                      {isOwned ? (
                        <button
                          type="button"
                          className="blue_btn"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigate("/previous-purchase");
                          }}
                          style={{
                            background: "#10B981",
                            borderColor: "#10B981",
                          }}
                        >
                          ✓ Owned - View Purchase
                        </button>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="blue_btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleBuyNow();
                            }}
                            disabled={addingToCart || checkingOwnership}
                          >
                            {addingToCart ? "Processing..." : "Buy Now"}
                          </button>
                          <button
                            type="button"
                            className="border_btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAddToCart("" , true);
                            }}
                            disabled={addingToCart || checkingOwnership}
                          >
                            {addingToCart ? "Adding..." : "Add to Cart"}
                          </button>
                        </>
                      )}
                    </div>

                  </div>

                    <p className="text_20 text-muted">
                      <span className="fw_700">Dimensions: </span>
                      {convertInchesToCm(
                        product?.fileDetails.recommendedPrintSize,
                      )}{" "}
                    </p>

                    {/* Action Buttons */}
                    {/* <div className="payment_details_btn_area">
                      {isOwned ? (
                        <button
                          type="button"
                          className="blue_btn"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigate("/previous-purchase");
                          }}
                          style={{
                            background: "#10B981",
                            borderColor: "#10B981",
                          }}
                        >
                          ✓ Owned - View Purchase
                        </button>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="blue_btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleBuyNow();
                            }}
                            disabled={addingToCart || checkingOwnership}
                          >
                            {addingToCart ? "Processing..." : "Buy Now"}
                          </button>
                          <button
                            type="button"
                            className="border_btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleAddToCart();
                            }}
                            disabled={addingToCart || checkingOwnership}
                          >
                            {addingToCart ? "Adding..." : "Add to Cart"}
                          </button>
                        </>
                      )}
                    </div> */}

                    {/* Accordion / Info */}
                    <div className="product_details_accordion_area">
                      <div className="product_accordion accordion">
                        <div className="accordion-item">
                          <div className="accordion-header font_one heading_text_6 text-uppercase active">
                            ARTIST DETAILS
                          </div>
                          <div className="accordion-content open">
                            <span className="fw_700 text_16">
                              {product?.artistId?.name} –{" "}
                              {product?.artistId?.subtitle}
                            </span>
                            <p className="text_16 m-0">
                              {product?.artistId?.description}
                            </p>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <div className="accordion-header font_one heading_text_6 text-uppercase active">
                            description
                          </div>
                          <div className="accordion-content open">
                            <p className="text_16 m-0">
                              <span className="fw_700">{product?.name}</span> is
                              a modern digital artwork that captures the{" "}
                              <span className="fw_700">calmness</span> of
                              twilight blending into the mysteries of night.
                              With deep blues and soft amber tones, it evokes
                              both serenity and curiosity — making it a perfect
                              piece for contemporary spaces.
                            </p>
                            <p className="text_16 m-0">
                              This painting{" "}
                              <span className="fw_700">
                                symbolizes the balance between endings and new
                                beginnings
                              </span>
                              , created with digital brushwork that blends fine
                              detail with abstract freedom.
                            </p>
                          </div>
                        </div>
                        {product?.fileDetails && (
                          <div className="accordion-item">
                            <div className="accordion-header font_one heading_text_6 text-uppercase active">
                              Digital File Details
                            </div>
                            <div className="accordion-content open">
                              <p className="text_16">
                                <span className="fw_700">Format:</span>{" "}
                                High-resolution JPG & PNG
                              </p>
                              <p className="text_16">
                                <span className="fw_700">Resolution:</span>{" "}
                                {product?.fileDetails?.resolution || "N/A"}
                              </p>
                              <p className="text_16">
                                <span className="fw_700">
                                  Recommended Print Size:
                                </span>{" "}
                                Up to{" "}
                                {product?.fileDetails?.recommendedPrintSize ||
                                  "N/A"}
                              </p>
                              <p className="text_16">
                                <span className="fw_700">File Size:</span>{" "}
                                {product?.fileDetails?.fileSize || "N/A"}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="accordion-item">
                          <div className="accordion-header font_one heading_text_6 text-uppercase active">
                            Download & Use
                          </div>
                          <div className="accordion-content open">
                            <p className="text_16">
                              Instant download after checkout
                            </p>
                            <p className="text_16">
                              Can be printed at home or through any professional
                              printing service
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ul className="payment_point_list text_16">
                      <li className="mb-1">
                        <span style={{ marginRight: "10px" }}>
                          <img
                            src="/assets/images/payment_point_icon.svg"
                            alt="payment_point_icon"
                          />
                        </span>
                        Secure Payments |{" "}
                        <a href="#" className="fw_500">
                          Multiple Options Available
                        </a>
                      </li>
                      <li className="mb-1">
                        <span style={{ marginRight: "10px" }}>
                          <img
                            src="/assets/images/payment_point_icon.svg"
                            alt="payment_point_icon"
                          />
                        </span>
                        (Instant digital download after purchase)
                      </li>
                    </ul>
                  </>
                ) : (
                  // PRINTS TAB CONTENT
                  <div className="prints_tab_content">
                    <div className="print_title_section" style={{ marginBottom: '25px' , display :'flex' , alignItems :'center' , justifyContent : 'space-between' , flexWrap :'wrap' , gap :'8px' }}>
                      <p style={{ 
                        fontSize: '14px', 
                        color: '#6B7280',
                        marginBottom: '4px',
                        fontWeight: '600'
                      }}>
                        {product?.artistId?.name} – {product?.artistId?.subtitle}
                      </p>
                        <div className="payment_details_btn_area" style={{ marginBottom: '30px' }}>
                      <button
                        type="button"
                        className="blue_btn"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          // Handle buy now for print
                          handleBuyNow(true)
                        }}
                      >
                        Buy Now
                      </button>
                      <button
                        type="button"
                        className="border_btn"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleAddToCart(true)
                          // Handle add to cart for print
                          
                        }}
                      >
                        Add to Cart
                      </button>
                    </div>
                    </div>

                    {/* Action Buttons */}
                    {/* <div className="payment_details_btn_area" style={{ marginBottom: '30px' }}>
                      <button
                        type="button"
                        className="blue_btn"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          // Handle buy now for print
                          console.log('Buy Now - Print:', {
                            material: selectedMaterial,
                            size: selectedSize,
                            wrap: selectedWrap,
                            frame: selectedFrame,
                            price: calculateTotalPrice()
                          });
                        }}
                      >
                        Buy Now
                      </button>
                      <button
                        type="button"
                        className="border_btn"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          // Handle add to cart for print
                          console.log('Add to Cart - Print:', {
                            material: selectedMaterial,
                            size: selectedSize,
                            wrap: selectedWrap,
                            frame: selectedFrame,
                            price: calculateTotalPrice()
                          });
                        }}
                      >
                        Add to Cart
                      </button>
                    </div> */}

                    {/* Open Edition Prints Available */}
                    <div className="print_section" style={{ marginBottom: '25px' }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px',
                        marginBottom: '15px'
                      }}>
                        <p style={{ 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#112C3B',
                          marginBottom: '0'
                        }}>
                          Open Edition Prints Available:
                        </p>
                        <div style={{
                          width: '16px',
                          height: '16px',
                          borderRadius: '50%',
                          background: '#112C3B',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '11px',
                          fontWeight: '700',
                          cursor: 'pointer'
                        }}>
                          i
                        </div>
                      </div>

                      {/* Material Selection */}
                      <div ref={materialRef} className="print_option_group" style={{ marginBottom: '20px', position: 'relative' }}>
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: '8px',
                          marginBottom: '10px'
                        }}>
                          <p style={{ 
                            fontSize: '14px', 
                            fontWeight: '600',
                            color: '#112C3B',
                            marginBottom: '0'
                          }}>
                            Select a Material
                          </p>
                          <div style={{
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            background: '#112C3B',
                            color: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '11px',
                            fontWeight: '700',
                            cursor: 'pointer'
                          }}>
                            i
                          </div>
                        </div>

                        {/* Dropdown Button */}
                        <div
                          onClick={() => setIsMaterialOpen(!isMaterialOpen)}
                          style={{
                            padding: '12px 16px',
                            background: '#F3F4F6',
                            color: '#112C3B',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <span>{selectedPrintMaterial?.name}</span>
                          <span style={{ 
                            transform: isMaterialOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}>▼</span>
                        </div>

                        {/* Dropdown Options */}
                        {isMaterialOpen && (
                          <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            right: '0',
                            background: '#fff',
                            border: '1px solid #E5E7EB',
                            borderTop: 'none',
                            zIndex: 10,
                            marginTop: '-1px'
                          }}>
                            {printMaterial.map((material) => (
                              <div
                                key={material}
                                onClick={() => {
                                  setSelectedPrintMaterial(material);
                                  setIsMaterialOpen(false);
                                }}
                                style={{
                                  padding: '12px 16px',
                                  background: selectedPrintMaterial?.name === material?.name ? '#112C3B' : '#fff',
                                  color: selectedPrintMaterial?.name === material?.name ? '#fff' : '#112C3B',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  transition: 'all 0.2s ease',
                                  borderBottom: '1px solid #E5E7EB'
                                }}
                                onMouseEnter={(e) => {
                                  if (selectedPrintMaterial?.name !== material?.name) {
                                    e.target.style.background = '#F3F4F6';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (selectedPrintMaterial?.name !== material?.name) {
                                    e.target.style.background = '#fff';
                                  }
                                }}
                              >
                                {material?.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Size Selection */}
                      <div ref={sizeRef} className="print_option_group" style={{ marginBottom: '20px', position: 'relative' }}>
                        <p style={{ 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#112C3B',
                          marginBottom: '10px'
                        }}>
                          Select a Size
                        </p>

                        {/* Dropdown Button */}
                        <div
                          onClick={() => setIsSizeOpen(!isSizeOpen)}
                          style={{
                            padding: '12px 16px',
                            background: '#F3F4F6',
                            color: '#112C3B',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <span>{selectedSize?.name}</span>
                          <span style={{ 
                            transform: isSizeOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}>▼</span>
                        </div>

                        {/* Dropdown Options */}
                        {isSizeOpen && (
                          <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            right: '0',
                            background: '#fff',
                            border: '1px solid #E5E7EB',
                            borderTop: 'none',
                            zIndex: 10,
                            marginTop: '-1px'
                          }}>
                            {sizes.map((size) => {
                              const displayText = `${size?.name} ($${size.price})`;
                              return (
                                <div
                                  key={size.name}
                                  onClick={() => {
                                    setSelectedSize(size);
                                    setIsSizeOpen(false);
                                  }}
                                  style={{
                                    padding: '12px 16px',
                                    background: selectedSize?.name === size.name ? '#112C3B' : '#fff',
                                    color:selectedSize?.name === size.name  ? '#fff' : '#112C3B',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    transition: 'all 0.2s ease',
                                    borderBottom: '1px solid #E5E7EB',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (selectedSize?.name !== size.name) {
                                      e.target.style.background = '#F3F4F6';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (selectedSize?.name !== size.name) {
                                      e.target.style.background = '#fff';
                                    }
                                  }}
                                >
                                  <span>{size.name}</span>
                                  <span>(${size.price})</span>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      {/* Canvas Wrap Selection */}
                      <div ref={wrapRef} className="print_option_group" style={{ marginBottom: '20px', position: 'relative' }}>
                        <p style={{ 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#112C3B',
                          marginBottom: '10px'
                        }}>
                          Select a Canvas Wrap
                        </p>

                        {/* Dropdown Button */}
                        <div
                          onClick={() => setIsWrapOpen(!isWrapOpen)}
                          style={{
                            padding: '12px 16px',
                            background: '#F3F4F6',
                            color: '#112C3B',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <span>{selectedCanvas?.name}</span>
                          <span style={{ 
                            transform: isWrapOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}>▼</span>
                        </div>

                        {/* Dropdown Options */}
                        {isWrapOpen && (
                          <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            right: '0',
                            background: '#fff',
                            border: '1px solid #E5E7EB',
                            borderTop: 'none',
                            zIndex: 10,
                            marginTop: '-1px'
                          }}>
                            {canvasWrap?.map((wrap) => (
                              <div
                                key={wrap._id}
                                onClick={() => {
                                  setSelectedCanvas(wrap);
                                  setIsWrapOpen(false);
                                }}
                                style={{
                                  padding: '12px 16px',
                                  background: selectedCanvas?.name === wrap?.name ? '#112C3B' : '#fff',
                                  color: selectedCanvas?.name === wrap?.name ? '#fff' : '#112C3B',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  transition: 'all 0.2s ease',
                                  borderBottom: '1px solid #E5E7EB'
                                }}
                                onMouseEnter={(e) => {
                                  if (selectedCanvas?.name !== wrap?.name) {
                                    e.target.style.background = '#F3F4F6';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (selectedCanvas?.name !== wrap?.name ) {
                                    e.target.style.background = '#fff';
                                  }
                                }}
                              >
                                {wrap?.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Frame Selection */}
                      <div ref={frameRef} className="print_option_group" style={{ marginBottom: '25px', position: 'relative' }}>
                        <p style={{ 
                          fontSize: '14px', 
                          fontWeight: '600',
                          color: '#112C3B',
                          marginBottom: '10px'
                        }}>
                          Add a Frame
                        </p>

                        {/* Dropdown Button */}
                        <div
                          onClick={() => setIsFrameOpen(!isFrameOpen)}
                          style={{
                            padding: '12px 16px',
                            background: '#F3F4F6',
                            color: '#112C3B',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            border: '1px solid #E5E7EB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                        >
                          <span>{selectedFrame?.name}</span>
                          <span style={{ 
                            transform: isFrameOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}>▼</span>
                        </div>

                        {/* Dropdown Options */}
                        {isFrameOpen && (
                          <div style={{
                            position: 'absolute',
                            top: '100%',
                            left: '0',
                            right: '0',
                            background: '#fff',
                            border: '1px solid #E5E7EB',
                            borderTop: 'none',
                            zIndex: 10,
                            marginTop: '-1px'
                          }}>
                            {frame.map((frame) => (
                              <div
                                key={frame.name}
                                onClick={() => {
                                  setSelectedFrame(frame);
                                  setIsFrameOpen(false);
                                }}
                                style={{
                                  padding: '12px 16px',
                                  background: selectedFrame?.name === frame.name ? '#112C3B' : '#fff',
                                  color: selectedFrame?.name === frame.name ? '#fff' : '#112C3B',
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  transition: 'all 0.2s ease',
                                  borderBottom: '1px solid #E5E7EB',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                                }}
                                onMouseEnter={(e) => {
                                  if (selectedFrame?.name !== frame.name) {
                                    e.target.style.background = '#F3F4F6';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (selectedFrame?.name !== frame.name) {
                                    e.target.style.background = '#fff';
                                  }
                                }}
                              >
                                <span>{frame.name}</span>
                                {frame.price > 0 && <span>(${frame.price})</span>}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Total Price Display */}
                      <div style={{
                        borderTop: '1px solid #e5e7eb',
                        paddingTop: '20px',
                        marginTop: '20px',
                        textAlign: 'center'
                      }}>
                        <div style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#6B7280',
                          marginBottom: '8px',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px'
                        }}>
                          Total Price
                        </div>
                        <div style={{
                          fontSize: '32px',
                          fontWeight: '700',
                          color: '#112C3B'
                        }}>
                          ${calculateTotalPrice()}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailsWithTabs;